/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Advisor } from './Advisor';
import {
    AdvisorFromJSON,
    AdvisorFromJSONTyped,
    AdvisorToJSON,
} from './Advisor';
import type { ContentSettings } from './ContentSettings';
import {
    ContentSettingsFromJSON,
    ContentSettingsFromJSONTyped,
    ContentSettingsToJSON,
} from './ContentSettings';
import type { ExternalLink } from './ExternalLink';
import {
    ExternalLinkFromJSON,
    ExternalLinkFromJSONTyped,
    ExternalLinkToJSON,
} from './ExternalLink';
import type { JobSearchData } from './JobSearchData';
import {
    JobSearchDataFromJSON,
    JobSearchDataFromJSONTyped,
    JobSearchDataToJSON,
} from './JobSearchData';
import type { LinkedinLearningAccount } from './LinkedinLearningAccount';
import {
    LinkedinLearningAccountFromJSON,
    LinkedinLearningAccountFromJSONTyped,
    LinkedinLearningAccountToJSON,
} from './LinkedinLearningAccount';
import type { MemberServiceType } from './MemberServiceType';
import {
    MemberServiceTypeFromJSON,
    MemberServiceTypeFromJSONTyped,
    MemberServiceTypeToJSON,
} from './MemberServiceType';
import type { MemberType } from './MemberType';
import {
    MemberTypeFromJSON,
    MemberTypeFromJSONTyped,
    MemberTypeToJSON,
} from './MemberType';
import type { PortalSettings } from './PortalSettings';
import {
    PortalSettingsFromJSON,
    PortalSettingsFromJSONTyped,
    PortalSettingsToJSON,
} from './PortalSettings';
import type { Process } from './Process';
import {
    ProcessFromJSON,
    ProcessFromJSONTyped,
    ProcessToJSON,
} from './Process';
import type { Programme } from './Programme';
import {
    ProgrammeFromJSON,
    ProgrammeFromJSONTyped,
    ProgrammeToJSON,
} from './Programme';
import type { TimeZoneInfo } from './TimeZoneInfo';
import {
    TimeZoneInfoFromJSON,
    TimeZoneInfoFromJSONTyped,
    TimeZoneInfoToJSON,
} from './TimeZoneInfo';

/**
 * 
 * @export
 * @interface CandidateMember
 */
export interface CandidateMember {
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    countryCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CandidateMember
     */
    hasCompanySearchExportFolder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CandidateMember
     */
    temporaryPassword?: boolean;
    /**
     * 
     * @type {PortalSettings}
     * @memberof CandidateMember
     */
    portalSettings?: PortalSettings;
    /**
     * 
     * @type {boolean}
     * @memberof CandidateMember
     */
    isProxyLogin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CandidateMember
     */
    proxyLoginShowDisclaimer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CandidateMember
     */
    canEditUserName?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CandidateMember
     */
    canEditPersonalData?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    editorId?: string;
    /**
     * 
     * @type {LinkedinLearningAccount}
     * @memberof CandidateMember
     */
    linkedinLearningAccount?: LinkedinLearningAccount;
    /**
     * 
     * @type {JobSearchData}
     * @memberof CandidateMember
     */
    jobSearchProfile?: JobSearchData;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    userName?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    language?: string;
    /**
     * 
     * @type {MemberServiceType}
     * @memberof CandidateMember
     */
    memberService?: MemberServiceType;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    mobile?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    linkedin?: string;
    /**
     * 
     * @type {MemberType}
     * @memberof CandidateMember
     */
    memberType?: MemberType;
    /**
     * 
     * @type {Advisor}
     * @memberof CandidateMember
     */
    advisor?: Advisor;
    /**
     * 
     * @type {Array<Advisor>}
     * @memberof CandidateMember
     */
    readonly secondaryAdvisors?: Array<Advisor>;
    /**
     * 
     * @type {boolean}
     * @memberof CandidateMember
     */
    acceptTermsSupported?: boolean;
    /**
     * 
     * @type {Array<ExternalLink>}
     * @memberof CandidateMember
     */
    links?: Array<ExternalLink>;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    businessArea?: string;
    /**
     * 
     * @type {ContentSettings}
     * @memberof CandidateMember
     */
    contentSettings?: ContentSettings;
    /**
     * 
     * @type {number}
     * @memberof CandidateMember
     */
    jobInterviews?: number;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    statusSegmentation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CandidateMember
     */
    personalDataValidForJobProfilePublish?: boolean;
    /**
     * 
     * @type {Process}
     * @memberof CandidateMember
     */
    progress?: Process;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    consent?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateMember
     */
    secondaryAdviser?: string;
    /**
     * 
     * @type {Array<Programme>}
     * @memberof CandidateMember
     */
    programmes?: Array<Programme>;
    /**
     * 
     * @type {Programme}
     * @memberof CandidateMember
     */
    selectedProgramme?: Programme;
    /**
     * 
     * @type {boolean}
     * @memberof CandidateMember
     */
    showUserName?: boolean;
    /**
     * 
     * @type {TimeZoneInfo}
     * @memberof CandidateMember
     */
    timeZone?: TimeZoneInfo;
}

/**
 * Check if a given object implements the CandidateMember interface.
 */
export function instanceOfCandidateMember(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CandidateMemberFromJSON(json: any): CandidateMember {
    return CandidateMemberFromJSONTyped(json, false);
}

export function CandidateMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): CandidateMember {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'country': !exists(json, 'Country') ? undefined : json['Country'],
        'countryCode': !exists(json, 'CountryCode') ? undefined : json['CountryCode'],
        'hasCompanySearchExportFolder': !exists(json, 'HasCompanySearchExportFolder') ? undefined : json['HasCompanySearchExportFolder'],
        'temporaryPassword': !exists(json, 'TemporaryPassword') ? undefined : json['TemporaryPassword'],
        'portalSettings': !exists(json, 'PortalSettings') ? undefined : PortalSettingsFromJSON(json['PortalSettings']),
        'isProxyLogin': !exists(json, 'IsProxyLogin') ? undefined : json['IsProxyLogin'],
        'proxyLoginShowDisclaimer': !exists(json, 'ProxyLoginShowDisclaimer') ? undefined : json['ProxyLoginShowDisclaimer'],
        'canEditUserName': !exists(json, 'CanEditUserName') ? undefined : json['CanEditUserName'],
        'canEditPersonalData': !exists(json, 'CanEditPersonalData') ? undefined : json['CanEditPersonalData'],
        'editorId': !exists(json, 'EditorId') ? undefined : json['EditorId'],
        'linkedinLearningAccount': !exists(json, 'LinkedinLearningAccount') ? undefined : LinkedinLearningAccountFromJSON(json['LinkedinLearningAccount']),
        'jobSearchProfile': !exists(json, 'JobSearchProfile') ? undefined : JobSearchDataFromJSON(json['JobSearchProfile']),
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'name': !exists(json, 'Name') ? undefined : json['Name'],
        'firstName': !exists(json, 'FirstName') ? undefined : json['FirstName'],
        'userName': !exists(json, 'UserName') ? undefined : json['UserName'],
        'email': !exists(json, 'Email') ? undefined : json['Email'],
        'language': !exists(json, 'Language') ? undefined : json['Language'],
        'memberService': !exists(json, 'MemberService') ? undefined : MemberServiceTypeFromJSON(json['MemberService']),
        'address': !exists(json, 'Address') ? undefined : json['Address'],
        'zip': !exists(json, 'Zip') ? undefined : json['Zip'],
        'phone': !exists(json, 'Phone') ? undefined : json['Phone'],
        'mobile': !exists(json, 'Mobile') ? undefined : json['Mobile'],
        'city': !exists(json, 'City') ? undefined : json['City'],
        'linkedin': !exists(json, 'Linkedin') ? undefined : json['Linkedin'],
        'memberType': !exists(json, 'MemberType') ? undefined : MemberTypeFromJSON(json['MemberType']),
        'advisor': !exists(json, 'Advisor') ? undefined : AdvisorFromJSON(json['Advisor']),
        'secondaryAdvisors': !exists(json, 'SecondaryAdvisors') ? undefined : ((json['SecondaryAdvisors'] as Array<any>).map(AdvisorFromJSON)),
        'acceptTermsSupported': !exists(json, 'AcceptTermsSupported') ? undefined : json['AcceptTermsSupported'],
        'links': !exists(json, 'Links') ? undefined : ((json['Links'] as Array<any>).map(ExternalLinkFromJSON)),
        'summary': !exists(json, 'Summary') ? undefined : json['Summary'],
        'businessArea': !exists(json, 'BusinessArea') ? undefined : json['BusinessArea'],
        'contentSettings': !exists(json, 'ContentSettings') ? undefined : ContentSettingsFromJSON(json['ContentSettings']),
        'jobInterviews': !exists(json, 'JobInterviews') ? undefined : json['JobInterviews'],
        'statusSegmentation': !exists(json, 'StatusSegmentation') ? undefined : json['StatusSegmentation'],
        'personalDataValidForJobProfilePublish': !exists(json, 'PersonalDataValidForJobProfilePublish') ? undefined : json['PersonalDataValidForJobProfilePublish'],
        'progress': !exists(json, 'Progress') ? undefined : ProcessFromJSON(json['Progress']),
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'consent': !exists(json, 'Consent') ? undefined : json['Consent'],
        'secondaryAdviser': !exists(json, 'SecondaryAdviser') ? undefined : json['SecondaryAdviser'],
        'programmes': !exists(json, 'Programmes') ? undefined : ((json['Programmes'] as Array<any>).map(ProgrammeFromJSON)),
        'selectedProgramme': !exists(json, 'SelectedProgramme') ? undefined : ProgrammeFromJSON(json['SelectedProgramme']),
        'showUserName': !exists(json, 'ShowUserName') ? undefined : json['ShowUserName'],
        'timeZone': !exists(json, 'TimeZone') ? undefined : TimeZoneInfoFromJSON(json['TimeZone']),
    };
}

export function CandidateMemberToJSON(value?: CandidateMember | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Country': value.country,
        'CountryCode': value.countryCode,
        'HasCompanySearchExportFolder': value.hasCompanySearchExportFolder,
        'TemporaryPassword': value.temporaryPassword,
        'PortalSettings': PortalSettingsToJSON(value.portalSettings),
        'IsProxyLogin': value.isProxyLogin,
        'ProxyLoginShowDisclaimer': value.proxyLoginShowDisclaimer,
        'CanEditUserName': value.canEditUserName,
        'CanEditPersonalData': value.canEditPersonalData,
        'EditorId': value.editorId,
        'LinkedinLearningAccount': LinkedinLearningAccountToJSON(value.linkedinLearningAccount),
        'JobSearchProfile': JobSearchDataToJSON(value.jobSearchProfile),
        'Id': value.id,
        'Name': value.name,
        'FirstName': value.firstName,
        'UserName': value.userName,
        'Email': value.email,
        'Language': value.language,
        'MemberService': MemberServiceTypeToJSON(value.memberService),
        'Address': value.address,
        'Zip': value.zip,
        'Phone': value.phone,
        'Mobile': value.mobile,
        'City': value.city,
        'Linkedin': value.linkedin,
        'MemberType': MemberTypeToJSON(value.memberType),
        'Advisor': AdvisorToJSON(value.advisor),
        'AcceptTermsSupported': value.acceptTermsSupported,
        'Links': value.links === undefined ? undefined : ((value.links as Array<any>).map(ExternalLinkToJSON)),
        'Summary': value.summary,
        'BusinessArea': value.businessArea,
        'ContentSettings': ContentSettingsToJSON(value.contentSettings),
        'JobInterviews': value.jobInterviews,
        'StatusSegmentation': value.statusSegmentation,
        'PersonalDataValidForJobProfilePublish': value.personalDataValidForJobProfilePublish,
        'Progress': ProcessToJSON(value.progress),
        'Title': value.title,
        'Consent': value.consent,
        'SecondaryAdviser': value.secondaryAdviser,
        'Programmes': value.programmes === undefined ? undefined : ((value.programmes as Array<any>).map(ProgrammeToJSON)),
        'SelectedProgramme': ProgrammeToJSON(value.selectedProgramme),
        'ShowUserName': value.showUserName,
        'TimeZone': TimeZoneInfoToJSON(value.timeZone),
    };
}

